import * as fromDatatype from '../datatype-library/index';

export interface bl_ocr_generic_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  ocr_scanned_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  algorithm_provider: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  ocr_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ocr_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  posting_membership: fromDatatype.VarcharDatatypeInterface;
  rejection_reason: fromDatatype.VarcharDatatypeInterface;
  ocr_company_hdr_name: fromDatatype.VarcharDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  scanned_doc_no: fromDatatype.VarcharDatatypeInterface;
}

export class bl_ocr_generic_doc_hdr_RowClass implements bl_ocr_generic_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  ocr_scanned_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  algorithm_provider: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  ocr_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ocr_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  posting_membership: fromDatatype.VarcharDatatypeInterface;
  rejection_reason: fromDatatype.VarcharDatatypeInterface;
  ocr_company_hdr_name: fromDatatype.VarcharDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  scanned_doc_no: fromDatatype.VarcharDatatypeInterface;
}
